import {Pipe, PipeTransform} from '@angular/core';
import {isNumber} from 'lodash-es';
import {DecimalPipe} from '@angular/common';

@Pipe({
    name: 'textNumber'
})
export class TextNumberPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) {
    }

    transform(value: unknown, zeroWillDisplay = '', nonZeroWillDisplay?: string): unknown {
        if (value) {
            if (isNumber(value)) {
                return this.decimalPipe.transform(value, '1.0-2');
            } else {
                return nonZeroWillDisplay ?? value;
            }
        } else {
            return zeroWillDisplay;
        }
    }
}
